module.exports = __webpack_public_path__ + "static/media/text-image.a763a2ae.png";